import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { pinDisponible } from '../lib/pinSession';
import EntryScreen from './EntryScreen';
import PinPantalla from '../pages/inspeccion/PinPantalla';
import { esRutaInspeccion } from '../lib/rutas';

// Traduce el vocabulario de ESTA app (hasAccess/roleResolved) al `estado` de la
// pantalla de entrada compartida. EntryScreen.jsx es copia de shared/vls-ui/ y
// NO se edita acá: se cambia en shared/ y se reparte con scripts/sync-ui.sh.
//
// Antes el login lo dibujaba `pages/login-screen/`, que este gate montaba. Esa
// página ya no se usa desde acá.
const MODULO = 'Cables y cuerdas';

const enlaceStyle = {
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 16,
  zIndex: 10000,
  textAlign: 'center',
};
const botonEnlaceStyle = {
  background: 'none',
  border: 0,
  padding: 12,
  font: 'inherit',
  fontSize: 14,
  textDecoration: 'underline',
  color: 'var(--color-muted-foreground, #78716C)',
  cursor: 'pointer',
};

const AuthGate = ({ children }) => {
  const { user, loading, isAuthenticated, roleResolved, hasAccess, rolError, signIn, signOut, reintentarRol } =
    useAuth();
  // Quien entra por /inspeccion sin sesión ve el PIN; el enlace de administración
  // cambia a este mismo login SSO sin tocar la ruta.
  const [verLogin, setVerLogin] = useState(false);
  // En el login SSO (fuera de /inspeccion) se ofrece "Soy inspector" solo si el
  // servidor confirma que el ingreso con PIN está habilitado.
  const [pinOk, setPinOk] = useState(false);
  // Fuerza un render tras cambiar la ruta con pushState (el gate vive fuera del router).
  const [, setRuta] = useState('');
  const enLoginSso = !loading && !isAuthenticated && !esRutaInspeccion(window.location.pathname);

  useEffect(() => {
    if (!enLoginSso) return undefined;
    let vivo = true;
    Promise.resolve()
      .then(() => pinDisponible())
      .then((ok) => { if (vivo) setPinOk(ok === true); })
      .catch(() => { if (vivo) setPinOk(false); });
    return () => { vivo = false; };
  }, [enLoginSso]);

  const irAlPin = () => {
    window.history.pushState({}, '', '/inspeccion');
    setVerLogin(false);
    setRuta('/inspeccion');
  };

  if (loading) return <EntryScreen modulo={MODULO} estado="cargando" />;
  if (!isAuthenticated) {
    const enInspeccion = esRutaInspeccion(window.location.pathname);
    if (!enInspeccion) {
      return (
        <>
          <EntryScreen modulo={MODULO} estado="login" onSignIn={signIn} />
          {pinOk ? (
            <div style={enlaceStyle}>
              <button type="button" style={botonEnlaceStyle} onClick={irAlPin}>
                Soy inspector: ingresar con PIN
              </button>
            </div>
          ) : null}
        </>
      );
    }
    if (verLogin) {
      return (
        <>
          <EntryScreen modulo={MODULO} estado="login" onSignIn={signIn} />
          <div style={enlaceStyle}>
            <button type="button" style={botonEnlaceStyle} onClick={() => setVerLogin(false)}>
              Volver al ingreso con PIN
            </button>
          </div>
        </>
      );
    }
    // El enlace de administración vive dentro de la pantalla de PIN (cabe en el
    // layout móvil sin tapar el teclado) y llama a este callback.
    return <PinPantalla onAdmin={() => setVerLogin(true)} />;
  }
  // Va ANTES que "sin resolver" a propósito: si la consulta del rol ya falló y
  // agotó su reintento automático, ya sabemos algo, y dejar a la persona en
  // "Cargando…" sería mentirle.
  if (rolError) {
    return (
      <EntryScreen modulo={MODULO} estado="error" onReintentar={reintentarRol} onSignOut={signOut} />
    );
  }
  if (!roleResolved) return <EntryScreen modulo={MODULO} estado="cargando" />;
  if (!hasAccess) {
    return (
      <EntryScreen modulo={MODULO} estado="sin-acceso" correo={user?.email} onSignOut={signOut} />
    );
  }
  return children;
};

export default AuthGate;
